import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        margin: 0,
        padding: 0
    },
    icon: {
        color: '#007a6d',
        transition: 'all 0.2s ease',
        '&:hover': {
            filter: 'brightness(1.2)',
        },
    }
}));

export {useStyles}